import { InputAdornment, Paper, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./userlist.scss";
import forwardArrow from "../../../assets/images/forwardArrow.svg";
import userAddIcon from "../../../assets/images/userAddIcon.svg";
import CustomPaper from "../../customWrapper/CustomPaper";
// import filterIcon from "../../../assets/images/filterIcon.svg";
import Filter from "../filter/Filter";
import { getUserList } from "../../../services/websiteApi";
import searchIcon from "../../../assets/images/search.svg";
import { Link, useNavigate } from "react-router-dom";
import {
  getParams,
  handleParams,
  isProd,
  searchParams,
} from "../../../utlis/helpers";
import { TEST_MODULE } from "../../../routes/routerPath";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../../state/actions/globalAction";
import closeIcon from "../../../assets/images/closeIcon.svg";
import { pageLocale } from "../../../utlis/locale";
import tabIcon from "../../../assets/images/tab.svg";

const UserList = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [searchField, setSearchField] = useState("");
  const [userlist, setUserList] = useState([]);
  const { locale } = getParams();
  // const storedTest = JSON.parse(sessionStorage.getItem("staffDetails"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    add_test_person,
    test_persons,
    firstname_lastname_id,
    incomplete_profile,
  } = pageLocale("landing");
  const searchhandler = (e) => {
    setSearchField(e.target.value);
  };

  useEffect(() => {
    const inputVal = searchField.toLowerCase();
    const updateList = userlist.map((j) => {
      if (
        j.name.toLowerCase().includes(inputVal) ||
        j.test_person_id.toLowerCase().includes(inputVal)
      ) {
        j.show = false;
      } else {
        j.show = true;
      }
      return j;
    });
    setUserList([...updateList]);
  }, [searchField]);

  const userInfo = (i, e) => {
    e.preventDefault();
    const userIndex = sessionStorage.getItem("userIndex");
    if (userIndex != i) {
      sessionStorage.removeItem("testMModule");
    }
    sessionStorage.setItem("userIndex", i);
    navigate(TEST_MODULE + `${searchParams}`);
    // navigate(USER_DETAILS + `${searchParams}`);
  };
  useEffect(() => {
    dispatch(setAPILoader(true));
    const userList = sessionStorage.getItem("userList");
    if (!userList) {
      getUserList(1, 999)
        .then((res) => {
          dispatch(setAPILoader(false));
          setUserList(res?.data?.data);
          sessionStorage.setItem("userList", JSON.stringify(res?.data?.data));
        })
        .catch(() => {
          dispatch(setAPILoader(false));
        });
    } else {
      dispatch(setAPILoader(false));
      setUserList(JSON.parse(userList));
    }
  }, []);
  const addTestPersonHandler = () => {
    sessionStorage.clear("userList");
    navigate(0);
  };

  const EditAddTestPersonHandler = (e, uuid) => {
    e.stopPropagation();
    //gobackWebsite query for resolve back  handler issue in Edit test person page
    window.location.href = `${isProd ? `https://testpersons.seniorlife.io` : `https://testpersons.dev.seniorlife.io`}/edit-test-person${handleParams()}&seniorUuid=${uuid}&showHeader=true&gobackWebsite=true`;
    sessionStorage.clear("userList");
  };
  return (
    <>
      <CustomPaper className="user-list-main-wrapper">
        <div className="user-list-header-wrap">
          <Typography className="header">{test_persons}</Typography>
          <div className="search-filter-wrapper">
            <TextField
              placeholder={firstname_lastname_id}
              variant="standard"
              className="serach-box"
              // type="search"
              value={searchField}
              onChange={(e) => searchhandler(e)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="search" className="search" />
                  </InputAdornment>
                ),
                endAdornment: searchField && (
                  <img src={closeIcon} onClick={() => setSearchField("")} />
                ),
                shrink: true,
              }}
            />
            {/* <img
              src={filterIcon}
              alt="filter"
              onClick={() => setShowFilter(true)}
              className="filter-icon"
            /> */}
          </div>
        </div>
        <div className="user-list-item-main-wrapper">
          {userlist?.map((item, index) => {
            return (
              !item.show && (
                <Paper
                  className="user-list-item-wrapper"
                  elevation={2}
                  key={index}
                  onClick={(e) => userInfo(index, e)}
                >
                  <div className="user-list-item">
                    <div className="user-list-first-block">
                      <div className="item">
                        <img
                          src={item.picture}
                          alt="user"
                          className="user-img"
                        />
                      </div>
                      <div className="item">
                        <Typography className="user-name">
                          {locale === "en"
                            ? item?.first_name + " " + item?.last_name
                            : item?.last_name + " " + item?.first_name}
                        </Typography>
                        <div className="user-info-block">
                          {item?.isIncompleteProfile && (
                            <div
                              className="incomplete-status"
                              onClick={(e) =>
                                EditAddTestPersonHandler(e, item?.id)
                              }
                            >
                              <div className="profile-status">
                                {incomplete_profile}{" "}
                                <img src={tabIcon} alt="tab" />
                              </div>
                            </div>
                          )}
                          <div className="subitem">
                            {(item?.gender || item?.age > 0) && (
                              <div className="item-first">
                                {item?.gender && (
                                  <>
                                    <Typography>{item?.gender}</Typography>
                                  </>
                                )}
                                {item?.gender && item?.age > 0 && (
                                  <div className="straight-line"></div>
                                )}
                                {item?.age > 0 && (
                                  <>
                                    <Typography> {item.age}</Typography>
                                  </>
                                )}
                              </div>
                            )}
                            <Typography className="item-second">
                              ID: {item.test_person_id}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="arrow-wrapper">
                      <img src={forwardArrow} alt="arrow" className="arrow" />
                    </div>
                  </div>
                </Paper>
              )
            );
          })}
        </div>
        <div className="landing-btn-wrapper">
          <Link
            to={`${isProd ? `https://testpersons.seniorlife.io` : `https://testpersons.dev.seniorlife.io`}/add-test-person${handleParams()}&showHeader=true`}
            // to={`${isProd ? `https://testpersons.seniorlife.io` : `https://testpersons.dev.seniorlife.io`}/add-test-person?staffId=${storedTest?.id}&showHeader=true&locale=${locale}&accessToken=${accessToken}`}
          >
            <button className="add-test-btn" onClick={addTestPersonHandler}>
              <img src={userAddIcon} className="user-add-icon" />
              {add_test_person}
            </button>
          </Link>
        </div>
      </CustomPaper>
      <Filter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        userlist={userlist}
      />
    </>
  );
};

export default UserList;
